export const availablePromoCodesInClynkQuery = /* GraphQL */`
    query availablePromoCodesInClynk($cleverlynkId: ID!){
        availablePromoCodesInClynk(cleverlynkId: $cleverlynkId)
    }
`